export const LOAD_ACTIVITY_DATA = 'LOAD_ACTIVITY_DATA'
export const SET_ACTIVITY_DATA = 'SET_ACTIVITY_DATA'
export const SET_ACTIVITY_DATA_OTHER_PLAYERS = 'SET_ACTIVITY_DATA_OTHER_PLAYERS'
export const SET_ACTIVITY_BATTLES_VISITING_PLAYERS = 'SET_ACTIVITY_BATTLES_VISITING_PLAYERS'
export const LOAD_ACTIVITY_BATTLES_VISITING_PLAYERS = 'LOAD_ACTIVITY_BATTLES_VISITING_PLAYERS'

export const loadActivityData = () => {
  return { type: LOAD_ACTIVITY_DATA }
}

export const setActivityData = (data) => {
  return { type: SET_ACTIVITY_DATA, data: data }
}

export const setActivityDataOthersPlayers = (data) => {
  return { type: SET_ACTIVITY_DATA_OTHER_PLAYERS, data: data }
}

export const setActivityDataVisitingPlayers = (data) => {
  return { type: SET_ACTIVITY_BATTLES_VISITING_PLAYERS, data: data }
}
export const loadActivityDataVisitingPlayers = (data) => {
  return { type: LOAD_ACTIVITY_BATTLES_VISITING_PLAYERS, data: data }
}
